import { render, staticRenderFns } from "./consulting.vue?vue&type=template&id=31def678&scoped=true"
import script from "./consulting.vue?vue&type=script&lang=js"
export * from "./consulting.vue?vue&type=script&lang=js"
import style0 from "./consulting.vue?vue&type=style&index=0&id=31def678&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31def678",
  null
  
)

export default component.exports